/**
 * The producer card titles that are part of a work item's **identity**, not
 * just its copy.
 *
 * `work_items` carries no subtype column, so a link-less producer row is
 * recognized by its title. That makes each constant load-bearing in two
 * packages at once — the backend reads and writes rows by it, and the web
 * client routes a card click on it — which is why they live in the leaf
 * package both can import rather than being spelled twice.
 *
 * Changing a string orphans every stored row wearing the old one; migrate them
 * in the same change.
 */

/** The card asking a member to verify the phone number on their account. */
export const UNVERIFIED_PHONE_WORK_ITEM_TITLE = 'Verify your phone number';
